import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";

export const returnsClaimsAnalyticsBreadcrumb = breadcrumbSlot();
export const productDetailsBreadcrumb = breadcrumbSlot();
